import { doc, getDoc } from 'firebase/firestore';
import { db } from './app';
import { User } from 'firebase/auth';

export interface UserRoles {
    isLittyAdmin: boolean;
    isBlogEditor: boolean;
    isEmailer: boolean;
}

export async function getUserRoles(user: User | null): Promise<UserRoles> {
    const defaultRoles: UserRoles = {
        isLittyAdmin: false,
        isBlogEditor: false,
        isEmailer: false
    };

    if (!user?.email) {
        return defaultRoles;
    }

    const roles: UserRoles = { ...defaultRoles };

    // Check each role individually and handle permission errors gracefully

    // Check admin emails (may fail for non-admins due to permissions)
    try {
        const adminDoc = await getDoc(doc(db, 'private', 'admin_emails'));
        roles.isLittyAdmin = adminDoc.exists() && adminDoc.data()?.[user.email] === true;
    } catch (error) {
        // Expected for non-admin users - they can't read private collections
        roles.isLittyAdmin = false;
    }

    // Check blog editor emails (should work for everyone)
    try {
        const blogEditorDoc = await getDoc(doc(db, 'blog_editor_emails', 'emails'));
        roles.isBlogEditor = blogEditorDoc.exists() && blogEditorDoc.data()?.[user.email] === true;
    } catch (error) {
        console.error('Error checking blog editor role:', error);
        roles.isBlogEditor = false;
    }

    // Check emailer emails (may fail for non-emailers due to permissions)
    try {
        const emailerDoc = await getDoc(doc(db, 'private', 'emailer_emails'));
        roles.isEmailer = emailerDoc.exists() && emailerDoc.data()?.[user.email] === true;
    } catch (error) {
        // Expected for non-emailer users - they can't read private collections
        roles.isEmailer = false;
    }

    return roles;
}

export async function isBlogEditor(user: User | null): Promise<boolean> {
    if (!user?.email) return false;

    try {
        const blogEditorDoc = await getDoc(doc(db, 'blog_editor_emails', 'emails'));
        return blogEditorDoc.exists() && blogEditorDoc.data()?.[user.email] === true;
    } catch (error) {
        console.error('Error checking blog editor role:', error);
        return false;
    }
}

export async function isLittyAdmin(user: User | null): Promise<boolean> {
    if (!user?.email) return false;

    try {
        const adminDoc = await getDoc(doc(db, 'private', 'admin_emails'));
        return adminDoc.exists() && adminDoc.data()?.[user.email] === true;
    } catch (error) {
        console.error('Error checking admin role:', error);
        return false;
    }
}